import { useCallback } from "react";
import { useGetContext } from "@onefront/forrestjs-react-root";

import { createProxyUrl } from "../utils/create-proxy-url";

export const useCreateTargetUrl = () => {
  const proxyBaseUrl = useGetContext("one.axios.proxy.baseUrl");

  /**
   * @param {string} target - URN (or URL as well) to be converted into a proxy url to redirect the user
   * @param {Array} params - Array of string to added as additional query parameters into the request
   *
   * @returns {string} The proxy url to be called
   */
  return useCallback(
    (target, params) => {
      const url = addParamsToUrl(target, params);

      return createProxyUrl(url, proxyBaseUrl);
    },
    [proxyBaseUrl]
  );
};

function addParamsToUrl(url, params) {
  if (url.indexOf("://") >= 0) {
    return params ? `${url}?${params?.join("&")}` : url;
  }

  return params ? `${url}://?${params?.join("&")}` : url;
}
